import type { VercelRunner } from '@cli-types/next-adapter/vercel.js'
import { spinner } from '@cli-utils/terminal.js'
import pc from 'picocolors'
import { createVercelProject } from '../project/create-vercel-project.js'
import { readLinkedProjectId } from '../project/read-linked-project-id.js'

export async function ensureLinkedProject(
  runner: VercelRunner,
  cwd: string,
  projectName: string,
  env?: NodeJS.ProcessEnv,
  scope?: string
): Promise<void> {
  if (readLinkedProjectId(cwd)) return

  const projectSpinner = spinner()
  projectSpinner.start(`Creating a Vercel project ${pc.cyan(projectName)}`)
  const project = await createVercelProject(runner, cwd, projectName, { env, scope })
  projectSpinner.clear()

  if (!project.linked || !project.projectId) {
    throw new Error(`Could not link Vercel project ${project.name} to this directory.`)
  }
}
